<template>
    <div class="proposeList">
        <!-- <div class="header">
            <img src="@/assets/new/fan.png"  @click="goHome" alt="">
            <span>我的奖励</span>
        </div> -->
        <div class="yhead">
            <img src="@/assets/c/yaohead.png" class="bg" alt="" />
            <div class="yaoname">
                <!-- <span class="yname"><span class="ytit">{{ $t('new.yaonames') }}</span>Galmcypro</span> -->
            </div>
        </div>
        <div class="tuanone">
            <div class="tone">
                <div class="items">
                    <img src="@/assets/c/img_tdzx_bj.png" class="bg" alt="" />
                    <div class="iviews">
                        <span class="tuanname">{{ $t("new.tuangai") }}</span>
                        <span class="tuanmiao">{{ all_number }}</span>
                    </div>
                </div>
            </div>
            <div class="tone ttwo">
                <div class="items">
                    <img src="@/assets/c/img_tdzx_bj.png" class="bg" alt="" />
                    <div class="iviews">
                        <span class="tuanname">{{ $t("new.zhiyhu") }}</span>
                        <span class="tuanmiao">{{ one_number }}</span>
                    </div>
                </div>
                <div class="items">
                    <img src="@/assets/c/img_tdzx_bj.png" class="bg" alt="" />
                    <div class="iviews">
                        <span class="tuanname">{{ $t("new.jianyhu") }}</span>
                        <span class="tuanmiao">{{ two_number }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="tlist">
            <div class="tlistone oview">
                <div class="ones">
                    {{ $t("new.shijian") }}
                </div>
                <div class="twos">
                    {{ $t("new.diming") }}
                </div>
                <!-- <div class="threes">
                    {{ $t('new.yleixing') }}
                </div> -->
            </div>
            <template v-if="sons.length > 0">
                <div class="huadong">
                    <div
                        class="tlistone tview"
                        v-for="(item, index) in sons"
                        :key="index"
                    >
                        <div class="ones">
                            {{ item.created_at }}
                        </div>
                        <div class="twos">
                            {{ item.show_address }}
                        </div>
                        <!-- <div class="threes">
                        {{ $t('new.zhiyhu') }}
                    </div> -->
                    </div>
                </div>
            </template>
            <div class="tlistone oview" v-else>
                <div
                    class="huadong"
                    style="
                        width: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    "
                >
                    No Data!
                </div>
            </div>
        </div>

        <div class="tlist" style="padding-top: 0">
            <div class="lone">
                <img src="@/assets/c/tuanview.png" class="bg" alt="" />
                <div class="loneview">
                    <span class="yihuo">{{ $t("new.yihuo") }}</span>
                    <span class="yihuotwo" style="display: flex; align-items: center;"
                        ><span style="font-size: 16px;">$</span>{{ rewards_all || 0 }}</span
                    >
                </div>
            </div>
            <div class="tlistone oview" style="margin-top: 10px">
                <div class="ones">
                    {{ $t("new.shijian") }}
                </div>
                <div class="twos">
                    {{ $t("new.jine") }}
                </div>
                <div class="threes">
                    {{ $t("new.yleixing") }}
                </div>
            </div>
            <template v-if="rewards.length > 0">
                <div class="huadong">
                    <div
                        class="tlistone tview"
                        v-for="(item, index) in rewards"
                        :key="index"
                    >
                        <div class="ones">
                            {{ item.created_at }}
                        </div>
                        <div class="twos">${{ item.bouns }}</div>
                        <div class="threes">
                            {{ item.level_name }}
                        </div>
                    </div>
                </div>
            </template>
            <div class="tlistone oview" v-else>
                <div
                    class="huadong"
                    style="
                        width: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    "
                >
                    No Data!
                </div>
            </div>
        </div>
        <div @click="$router.go(-1)" class="fanyao">{{ $t("new.fanyao") }}</div>
        <div @click="toUrl(setting.cooperation)" class="fanyao twobtn">{{ $t("new.swu") }}</div>

        <div class="fanview" @click="$router.go(-1)">
            <img src="@/assets/c/fan.png" class="bg" alt="" />
        </div>
    </div>
</template>

<script>
import { useNumberAnimation } from "@/libs/util.js";
import { ajaxData } from "@/api/ajax";
export default {
    data() {
        return {
            all_number: 0,
            one_number: 0,
            two_number: 0,
            sons: [],
            rewards: [],
            rewards_all: 0,
            setting : {}
        };
    },
    created() {
        this.getUserTeam();
        this.getSetting();
    },
    methods: {
        getUserTeam() {
            ajaxData("/user/team", {}).then((res) => {
                this.all_number = res.data.all_number;
                this.one_number = res.data.one_number;
                this.two_number = res.data.two_number;
                this.sons = res.data.sons;
                this.rewards = res.data.rewards;
                this.rewards_all = res.data.rewards_all;
            });
        },
        goHome() {
            this.$router.go(-1);
        },
        getSetting() {
            let vm = this;
            ajaxData("/setting", { key: "default" }).then((response) => {
                this.setting = response.data?.setting;
            });
        },
        toUrl(url) {
            window.location.href = url;
        },
    },
};
</script>


<style scoped lang="less">
p {
    margin: 0;
    padding: 0;
}

.proposeList {
    width: 100%;
    min-height: 100vh;
    background: rgba(19, 19, 19, 1);
    padding: 30px 15px;
    .tuanone {
        display: flex;
        flex-direction: column;
        .tone {
            display: flex;
            align-items: center;
            justify-content: center;
            .items {
                width: 113px;
                position: relative;
                height: 45px;

                // padding-top: 7px;
            }
            .iviews {
                position: relative;
                width: 100%;
                display: flex;
                height: 100%;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                .tuanname {
                    font-weight: 400;
                    font-size: 10px;
                    color: #cccccc;
                }
                .tuanmiao {
                    font-weight: bold;
                    font-size: 16px;
                    color: #26e7fe;
                    line-height: 16px;
                }
            }
        }
        .ttwo {
            display: flex;
            justify-content: space-around;
            margin-top: 19px;
        }
    }
    .tlist {
        background: #1a3542;
        border-radius: 10px;
        border: 0.5px solid #26e7fe;
        padding: 15px;
        display: flex;
        flex-direction: column;
        margin-top: 12px;
        .tlistone {
            font-weight: 500;
            font-size: 10px;
            color: #cccccc;
            display: flex;
            flex-direction: row;
            align-items: center;
            .ones {
                width: 50%;
            }
            .twos {
                flex: 1;
            }
            .threes {
                flex: 1;
            }
        }
        .tview {
            padding: 10px 0;
            font-weight: 500;
            font-size: 12px;
            color: #ffffff;
        }
    }
    .lone {
        width: 183px;
        height: 40px;
        position: relative;
        margin: 0 auto;
        .loneview {
            display: flex;
            width: 100%;
            align-items: center;
            justify-content: center;
            height: 100%;
            flex-direction: column;
            position: relative;
            .yihuo {
                font-weight: 400;
                font-size: 10px;
                color: #111111;
            }
            .yihuotwo {
                font-weight: bold;
                font-size: 16px;
                color: #111111;
                line-height: 16px;
            }
        }
    }
    .fanyao {
        width: 200px;
        height: 44px;
        background: #26e7fe;
        border-radius: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: 14px;
        color: #1a1a1a;
        margin: 14px auto;
    }
    .twobtn {
        background: #333333;
        color: #fff;
    }
    .header {
        height: 50px;
        // margin-bottom: 12px;
        // padding: 40px 12px 0 12px;
        padding: 6px;
        box-sizing: border-box;
        background: rgba(52, 56, 75, 1);
        display: flex;
        align-items: center;
        justify-content: center;
        position: sticky;
        width: 100%;
        z-index: 10;
        top: 0;
        img {
            width: 55px;
            height: 55px;
            position: absolute;
            left: 10px;
        }

        span {
            font-weight: bold;
            font-size: 18px;
            color: #ffffff;
        }
    }

    .mhead {
        // position: relative;
        // top: 50px;
    }
}
.huadong {
    height: 170px;
    overflow-y: auto;
}
::-webkit-scrollbar {
    display: none;
}
.yhead {
    // padding: 20px 7px;
    height: 82px;
    position: absolute;
    width: 90%;
    margin: 0 auto;

    // object-fit: cover;
    // padding: 30px auto;
    .yaohead {
        height: 82px;
        position: relative;
        width: 100%;
        object-fit: cover;
    }

    .yaoname {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        flex-direction: row;

        .yname {
            font-weight: bold;
            font-size: 23px;
            color: #ffffff;
            position: relative;
            top: 0px;
        }

        .ytit {
            font-weight: 500;
            // font-size: 20px;
            color: #26e7fe;
        }
    }
}
</style>
